export interface ElementPadding {
    padding: string;
    paddingTop: string;
    paddingRight: string;
    paddingBottom: string;
    paddingLeft: string;
}

export class ElementPaddingUtil {
    public static capture(element: HTMLElement): ElementPadding {
        return {
            padding: element.style.padding,
            paddingTop: element.style.paddingTop,
            paddingRight: element.style.paddingRight,
            paddingBottom: element.style.paddingBottom,
            paddingLeft: element.style.paddingLeft
        }
    }

    public static apply(element: HTMLElement, padding: Partial<ElementPadding>): void {
        if (element == null || padding == null) {
            return;
        }
        if (padding.padding != null) {
            element.style.padding = padding.padding;
        }
        if (padding.paddingTop != null) {
            element.style.paddingTop = padding.paddingTop;
        }
        if (padding.paddingRight != null) {
            element.style.paddingRight = padding.paddingRight;
        }
        if (padding.paddingBottom != null) {
            element.style.paddingBottom = padding.paddingBottom;
        }
        if (padding.paddingLeft != null) {
            element.style.paddingLeft = padding.paddingLeft;
        }
    }
}
